import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';
import { MatDialog } from '@angular/material';
import { DialogConfirmation } from '../dialogs-messages/dialog_confirmation.component';
import { DialogCommonError } from '../dialogs-errors/dialog-common-error.component';
import { FormGroup, FormControl, FormGroupDirective, NgForm, Validators, FormBuilder } from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

export class ErrorMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}
@Component({
    selector: 'app-nous-contacter',
    templateUrl: './nous-contacter.component.html',
    styleUrls: ['./nous-contacter.component.scss']
})

export class NousContacterComponent implements OnInit {

    required = [];
    formContact: any;
    matcher = new ErrorMatcher();
    objetFormControl = new FormControl('', [Validators.required]);
    prenomFormControl = new FormControl('', [Validators.required]);
    nomFormControl = new FormControl('', [Validators.required]);
    emailFormControl = new FormControl('', [Validators.required, Validators.email]);
    demandeFormControl = new FormControl('', [Validators.required]);

    constructor (
        private formBuilder: FormBuilder,
        private appService: AppService,
        public dialog: MatDialog,
    ) {}

    ngOnInit() {
        this.formContact = this.formBuilder.group({
            objet: this.objetFormControl,
            prenom: this.prenomFormControl,
            nom: this.nomFormControl,
            email: this.emailFormControl,
            demande: this.demandeFormControl
        })
    }

    sendForm() {
        if (!this.formContact.invalid) {
            this.appService.contactSupport(this.formContact.getRawValue()).subscribe((res) => {
                if (res.success == true) {
                    const dialogRef = this.dialog.open(DialogConfirmation, {
                        width: '100%',
                        panelClass:'abandon-dialog',
                        data: "Votre demande a bien été envoyée."
                    })
                } else {
                    const dialogRef = this.dialog.open(DialogCommonError, {
                        width: '100%',
                        panelClass:'abandon-dialog',
                        data : "Un problème est survenu, veuillez réessayer ultérieurement.",
                    });
                }
            });
        }
    }

}
